import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './subscription-plan-specification.reducer';
import { ISubscriptionPlanSpecification } from 'app/shared/model/subscription-plan-specification.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ISubscriptionPlanSpecificationProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const SubscriptionPlanSpecification = (props: ISubscriptionPlanSpecificationProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { subscriptionPlanSpecificationList, match, loading } = props;
  return (
    <div>
      <h2 id="subscription-plan-specification-heading">
        Subscription Plan Specifications
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Subscription Plan Specification
        </Link>
      </h2>
      <div className="table-responsive">
        {subscriptionPlanSpecificationList && subscriptionPlanSpecificationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Specification Name</th>
                <th>Created On</th>
                <th>Subscription Plan</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {subscriptionPlanSpecificationList.map((subscriptionPlanSpecification, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${subscriptionPlanSpecification.id}`} color="link" size="sm">
                      {subscriptionPlanSpecification.id}
                    </Button>
                  </td>
                  <td>{subscriptionPlanSpecification.specificationName}</td>
                  <td>
                    {subscriptionPlanSpecification.createdOn ? (
                      <TextFormat type="date" value={subscriptionPlanSpecification.createdOn} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {subscriptionPlanSpecification.subscriptionPlan ? (
                      <Link to={`subscription-plan/${subscriptionPlanSpecification.subscriptionPlan.id}`}>
                        {subscriptionPlanSpecification.subscriptionPlan.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${subscriptionPlanSpecification.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${subscriptionPlanSpecification.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${subscriptionPlanSpecification.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Subscription Plan Specifications found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ subscriptionPlanSpecification }: IRootState) => ({
  subscriptionPlanSpecificationList: subscriptionPlanSpecification.entities,
  loading: subscriptionPlanSpecification.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlanSpecification);
